import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';

export default function StripeConnectSuccess() {
  return (
    <div className="text-center">
      <FontAwesomeIcon icon={faCheckCircle} className="me-2" size="3x" color="#00d27a" />
      <p className="mt-4 text-800 font-sans-serif fw-semi-bold mx-4">
        Stripe onboarded successfully. Please open the CabFare app on your phone to start taking
        payments.
      </p>
    </div>
  );
}
